import Editor, { useMonaco } from "@monaco-editor/react";
import React, { useContext, useEffect, useRef } from "react";
import { DynamicFormUtilsDataContext } from "../..";
import FieldHeader from "../FieldHeader";

function CodeParameters({
  parametersModel,
  parameters,
  onParameterChange,
  utilsData,
}) {
  const monaco = useMonaco();
  const ref = useRef(null);

  const [dynamicFormUtilsDataContext, updateContext] = useContext(
    DynamicFormUtilsDataContext
  );

  useEffect(() => {
    // appelé 2 fois ! il faut corriger !!!!

    let disposable = null;
    if (monaco && dynamicFormUtilsDataContext.codeContext) {
      disposable = monaco.languages.registerCompletionItemProvider("python", {
        provideCompletionItems: function (model, position) {
          const word = model.getWordUntilPosition(position);

          const suggestions = [
            ...Object.values(
              dynamicFormUtilsDataContext.codeContext?.data || []
            ),
            ...Object.values(
              dynamicFormUtilsDataContext.codeContext?.meta_data || []
            ),
            ...Object.values(
              dynamicFormUtilsDataContext.codeContext?.output || []
            ),
          ].flat();

          return {
            suggestions: suggestions
              .filter((value, index) => {
                return suggestions.indexOf(value) === index;
              })
              .map((name) => {
                return {
                  label: name,
                  kind: monaco.languages.CompletionItemKind.Function,
                  documentation: "",
                  insertText: name,
                  range: {
                    startLineNumber: position.lineNumber,
                    endLineNumber: position.lineNumber,
                    startColumn: word.startColumn,
                    endColumn: word.endColumn,
                  },
                };
              }),
          };
        },
      });
    }
    return () => {
      disposable?.dispose();
    };
  }, [dynamicFormUtilsDataContext.codeContext]);

  const manageValue = (value) => {
    value = { ...value };
    value = value["code"];
    if (typeof value !== "string") {
      try {
        value = JSON.stringify(value);
      } catch (e) {
        value = value.toString();
      }
    }
    return value;
  };

  const manageChange = (value) => {
    onParameterChange({ is_code: true, code: value });
  };

  const getLanguage = function () {
    return parameters.language || "json";
  };

  return (
    <div>
      <FieldHeader
        label={parametersModel.label}
        description={parametersModel.description}
      />
      <div>
        <span>language: </span>
        <span>{getLanguage()}</span>
      </div>
      <Editor
        ref={ref}
        height="300px"
        language={getLanguage()}
        theme="vs-dark"
        options={{
          minimap: {
            enabled: false,
          },
          lineNumbersMinChars: 2,
          wordWrap: "on",
          indentation: "spaces",
          tabSize: 2,
        }}
        value={manageValue(parameters)}
        onChange={manageChange}
      />
    </div>
  );
}

export default CodeParameters;
